import { render, staticRenderFns } from "./TopProperties.vue?vue&type=template&id=cdff1e86&"
import script from "./TopProperties.vue?vue&type=script&lang=ts&"
export * from "./TopProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports